import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useAuth, useGrid, useStore, useToast, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_PAY_DSCR_LIST, SF_PAY_DSCR_LIST_SRCH } from "./services/OsciRcptService"; // 서비스
import dayjs from "dayjs";

/*
 * Pay Discrepancy List
 * !== 납부 불일치 목록 ==!
 */
export const OSCI0402008Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0066" }, { area: "bnkCd" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Pay Discrepancy Search !== 납부 불일치 검색 ==!
        payDscrSrch: useForm({
            defaultSchema: SF_PAY_DSCR_LIST_SRCH,
            defaultValues: {
                ...pgeStore?.form,
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Pay Discrepancy List !== 납부 불일치 목록 ==!
        payDscrList: useGrid({
            defaultSchema: SG_PAY_DSCR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Pay Discrepancy List !== 납부 불일치 목록 조회 ==!
        getPayDscrList: useFetch({
            api: (page = grid.payDscrList.page) => {
                let data = {
                    ...form.payDscrSrch.getValues(),
                    orgCd: auth.get("orgCd"),
                };
                return APIS.getPayDscrList(data, page, grid.payDscrList.size);
            },
            enabled: comnUtils.isEmpty(form.payDscrSrch.errors) && form.payDscrSrch.isSubmitted,
            key: [grid.payDscrList.page, grid.payDscrList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.payDscrSrch.getValues(),
                    page: grid.payDscrList.page,
                    size: grid.payDscrList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Pay Discrepancy List !== 납부 불일치 목록 조회 ==!
        getPayDscrList: (page: number = 0) => {
            form.payDscrSrch.handleSubmit(
                (data) => {
                    // Validation Check !== 밸리데이션 체크 ==!
                    grid.payDscrList.setPage(page);
                    fetch.getPayDscrList.fetch(page);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_payDscrList: {
            head: {},
            cell: {
                bllNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Layout direction="col" gap={1}>
                            <span style={{ color: "blue" }}>
                                <Link
                                    to={`${URLS.osci0401002q}/${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                                >{`${rowValues.bllNo}`}</Link>
                            </span>
                        </Layout>
                    );
                },
                tansadNo: (props: any) => {
                    const { binding, rowValues, value } = props;

                    console.log(rowValues);

                    if (rowValues.reffKeyTpCd == "T") {
                        return (
                            <Layout direction="col" gap={1}>
                                <span style={{ color: "blue" }}>
                                    <Link
                                        to={`${URLS.osci0401003q}/${rowValues.reffKeyNo1}-${rowValues.reffKeyNo2}-${rowValues.reffKeyNo3}/OSCI0402003Q`}
                                    >{`${rowValues.reffKeyNo1}-${rowValues.reffKeyNo2}-${rowValues.reffKeyNo3}`}</Link>
                                </span>
                            </Layout>
                        );
                    }
                },
            },
            edit: {},
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getPayDscrList(pgeStore?.page);
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Layout direction="row">
                            <Layout.Left size={6}>{}</Layout.Left>
                            <Layout.Right>{}</Layout.Right>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                {/* Bill Date !== 고지서 일자 ==!  */}
                                <Group.Control {...form.payDscrSrch.schema.bllDtmRnge}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                {/* Receipt Registration Date !== 수납 등록 일자 ==!  */}
                                <Group.Control {...form.payDscrSrch.schema.rcptRgsrDtmRnge}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                {/* Pay Discrepancy Type Code !== 납부 불일치 코드 ==!  */}
                                <Group.Control {...form.payDscrSrch.schema.dscrTpCd}></Group.Control>
                                <Group.Control {...form.payDscrSrch.schema.bllNo}></Group.Control>
                            </Group.Row>
                        </Group.Section>

                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.payDscrSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getPayDscrList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    grid.payDscrList.exportExcel({
                                        /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                        excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,
                                        /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                        sheetName: "Sheet Name",
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Grid
                        {...grid.payDscrList.grid}
                        data={fetch.getPayDscrList.data?.payDscrList}
                        render={render.grid_payDscrList}
                    />
                </Group.Body>
            </Group>
            <Layout direction="row"></Layout>
        </Page>
    );
};
